export enum MediaType {
  productImage = 'productImage'
}
